const executeIfFunction = (f) => (typeof f === 'function' ? f() : f)

const _switchcase = (cases) => <T>(defaultCase: T) => (key) =>
    cases.hasOwnProperty(key) ? cases[key] : defaultCase

export const switchcase = (cases) => <T>(defaultCase: T) => (key): T =>
    executeIfFunction(_switchcase(cases)(defaultCase)(key))

export default switchcase
